import React from "react";
import bonus from "../../components/secrets.jpeg";

function Secrets() {
  return (
    <div className="container">
      <div className="banner">
        <img src={bonus} alt="" />
      </div>

      <div className="container_body">
        <div className="course">
          <h1>Credit Card Secrets (BONUS)</h1>
          <h1 style={{ textAlign: "center" }}>BONUS</h1>
          <p>What lenders pull from which credit bureaus? </p>
          <p>
            Become familiar with who pulls from which bureaus. For example,
            Alliant Credit Union pulls from Equifax.
          </p>
          <p>
            They have a 2% Visa Signature card. They don't have any rules. They
            don’t have many cards either; however, they’ll give us a decent
            limit between $7,500.00-$15,000.00 depending on your data points at
            the time of applying. Barclays does have rules. They have the
            Aviator Card with American Airlines. This card gives you a free
            companion pass. Whenever you buy a ticket, you get one free after
            you spend $25,000.00.
          </p>
          <p>
            When you go to apply for Barclays, they don't have a 5 cards in 24
            months rule like Chase or some of these other banks. They only allow
            one credit card a day. Bank of America pulls from Experian, and the
            card that we want from them is the Business Advantage card. They
            have a 2/3/4 rule which means you can receive 2 cards every 2
            months, 3 cards every 12 months, or 4 cards every 24 months. The
            beautiful part about the rule is you can acquire those 2 cards on
            the same day every 2 months. That rule is in their policies and
            procedures. Make sure to stay current on any online content
            regarding credit card and the user experience. There are plenty of
            reputable online chat rooms and blogs, which allow customers to
            communicate their experiences and specific details of each credit
            card. Make sure to read the rules and look for loopholes in the
            policies of each credit card in case there are any changes made
            which benefit yourself or your clients.
          </p>
          <p>
            American Express pulls from Experian. If you are in a region like
            Texas, they may pull from all three credit bureaus. They have a rule
            in which you can only be approved for 2 non-charge cards every 90
            days. With Amex, there are platinum, gold, black, plum, and green
            cards. These are cards with no preset spending limits. It doesn't
            show on your credit as having a preset spending limit. We want to
            keep that in mind.
          </p>
          <p>
            We can get 2 non-charge cards, as well as an unlimited number of
            charge cards except for the platinum card. You can only get one
            platinum card every 30 days. Charles Schwab has a platinum card in
            partnership with American Express. Since Charles Schwab has a
            platinum card, we can apply through Charles Schwab for a platinum
            card with them as well. When you open up a Charles Schwab account,
            you'll check an account and get the platinum card. Then you have the
            Everyday Cash Preferred Card, which would be your tradeline card.
            You have a Gold Business Card, and Hilton Honors American Express
            Business Credit Card.
          </p>
          <p>
            Chase, American Express, and Discover are not too strict on
            inquiries. Those are the ones we do last for a reason. The main
            focus is we can do this first line first. Go to Alliant Credit Union
            and apply for the 2% Visa Signature card. They will pull from
            Equifax. Then, go to Barclays and get the Aviator Card. They will
            pull from TransUnion. Then, go to Bank of America and apply for a
            Business Advantage Travel card. Apply for the Bank of America
            Advantage Cash Card, which pulls from Experian. Here is an example
            of securing four credit cards, with only one inquiry on each report.
            Then, go to Capital One and apply for the Savior or SaviorOne card
            or one of the Venture Cards. Savior and SaviorOne had been giving
            $30,000.00 lines of credit. That's going to put you at two
            inquiries, but you already have 6 cards
          </p>
        </div>
        {/* <div className="downloads"></div> */}
      </div>
    </div>
  );
}

export default Secrets;
